import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { Tooltip } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './HowToBookAlertContent.scss';

const ThirdSectionContentBullet = ({ index }) => (
  <li>
    {trans(`listing.how-to-book.paid-plan.3-text.point-${index}`)}
    <Tooltip
      className="how-to-book-alert-content__tooltip"
      color="blue-cerulean"
      tooltip={trans(
        `listing.how-to-book.paid-plan.3-text.point-${index}.tooltip`
      )}
      placement="top"
      trigger={['click', 'hover']}
    >
      <DSIcon name="help_circle" />
    </Tooltip>
  </li>
);

ThirdSectionContentBullet.propTypes = {
  index: PropTypes.number.isRequired
};

export const ThirdSectionContent = ({ hasRentCollection }) => (
  <Fragment>
    <p className="how-to-book-alert-content">
      {trans('listing.how-to-book.paid-plan.3-text.content')}
    </p>
    <ul className="how-to-book-alert-content">
      <ThirdSectionContentBullet index={1} />
      <ThirdSectionContentBullet index={2} />
      {hasRentCollection && <ThirdSectionContentBullet index={3} />}
    </ul>
  </Fragment>
);

ThirdSectionContent.propTypes = {
  hasRentCollection: PropTypes.bool.isRequired
};

export const FourthSectionContent = () => (
  <p className="how-to-book-alert-content">
    {trans('listing.how-to-book.paid-plan.4-text.content')}
  </p>
);
